import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/hooks/use-toast'
import { agentTokensApi } from '../api/agentTokensApi'

const AGENT_TOKENS_KEY = 'easel-agent-tokens'

export function useAgentTokens() {
  return useQuery({
    queryKey: [AGENT_TOKENS_KEY],
    queryFn: () => agentTokensApi.list(),
  })
}

export function useMintAgentToken() {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: (label?: string) => agentTokensApi.mint(label),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [AGENT_TOKENS_KEY] })
      // No toast on success: the token itself is the result and it is shown once. A toast
      // that draws the eye away from a value you can never see again is the wrong nudge.
    },
    onError: (error: Error) => {
      toast({ title: 'Could not create token', description: error.message, variant: 'destructive' })
    },
  })
}

export function useRevokeAgentToken() {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: (jti: string) => agentTokensApi.revoke(jti),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [AGENT_TOKENS_KEY] })
      toast({ title: 'Token revoked', description: 'It stops working immediately.' })
    },
    onError: (error: Error) => {
      toast({ title: 'Could not revoke', description: error.message, variant: 'destructive' })
    },
  })
}
